// extracted by mini-css-extract-plugin
module.exports = {"loader":"spinner_loader__2BH9c","spinner":"spinner_spinner__2nH5c","spinnerCancel":"spinner_spinnerCancel__2JZrT"};